import type { Route } from '@angular/router';
import { dirtyCheckCanDeactivateGuard } from '../../common/dirty-check/dirty-check';
import { hasStringPathParamCanActivateGuard } from '@pct/ng-core-router';

export const notificationRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./list/notification-list.component'),
    pathMatch: 'full',
  },
  {
    path: 'new',
    loadComponent: () =>
      import('./details/notifications-details.component').then(
        ({ NotificationDetailsComponent }) => NotificationDetailsComponent,
      ),
    title: 'PAGES.NOTIFICATIONS.BREADCRUMB.NEW',
    canDeactivate: [dirtyCheckCanDeactivateGuard('HasDirtyCheck')],
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./details/notifications-details.component').then(
        ({ NotificationDetailsComponent }) => NotificationDetailsComponent,
      ),
    title: 'PAGES.NOTIFICATIONS.BREADCRUMB.EDIT',
    canActivate: [hasStringPathParamCanActivateGuard('id')],
    canDeactivate: [dirtyCheckCanDeactivateGuard('HasDirtyCheck')],
  },
];
